import dayjs from 'dayjs';

import { BankNames, DictTypes } from '@/constants';
import type { TDict } from '@/types/dicts';
import type { TModalTSValues } from '@/types/financing';

import type { VehicleFormInterface } from '../entities/vehicle-modal/types/vehicle-form';

interface IGetVisibleVehicleInfoFieldsOptions {
  bankName: BankNames;
  isEuBankOfflineProcess: boolean;
}

export const getVisibleVehicleInfoFieldsMap = (
  options: IGetVisibleVehicleInfoFieldsOptions
): Record<keyof VehicleFormInterface, boolean> => {
  const { bankName, isEuBankOfflineProcess } = options;

  if (bankName === BankNames.ffb) {
    return {
      vin: true,
      licensePlate: false,
      bodyNum: false,
      paymentDate: false,
      registerDate: false,
      registerCompany: false,
      engineCapacity: false,
      carColor: false,
      registerNum: false
    };
  }

  if (bankName === BankNames.euBankV2) {
    return {
      vin: true,
      licensePlate: isEuBankOfflineProcess,
      bodyNum: false,
      paymentDate: false,
      registerDate: isEuBankOfflineProcess,
      registerCompany: false,
      engineCapacity: false,
      carColor: false,
      registerNum: isEuBankOfflineProcess
    };
  }

  // Разделяем возврат по ключевому условию, иначе в объекте начинается каша из условий
  return {
    vin: true,
    licensePlate: true,
    bodyNum: true,
    paymentDate: true,
    registerDate: true,
    registerCompany: true,
    engineCapacity: true,
    carColor: true,
    registerNum: true
  };
};

export const getVisibleVehicleInfoFields = (
  options: IGetVisibleVehicleInfoFieldsOptions
): (keyof VehicleFormInterface)[] => {
  const result: (keyof VehicleFormInterface)[] = [];

  const visibleVehicleFormValues = getVisibleVehicleInfoFieldsMap(options);

  for (const _key in visibleVehicleFormValues) {
    const key = _key as keyof VehicleFormInterface;
    if (visibleVehicleFormValues[key]) {
      result.push(key);
    }
  }

  return result;
};

export const getVehicleInfoFormValues = ({
  tsModalValues,
  dicts,
  options
}: {
  tsModalValues: TModalTSValues;
  dicts: TDict;
  options: IGetVisibleVehicleInfoFieldsOptions;
}): Partial<VehicleFormInterface> => {
  const visibleFields = getVisibleVehicleInfoFields(options);

  const registerCompany =
    dicts[DictTypes.VehicleRegistrationCompanies]?.getBy.code[
      tsModalValues.registerCompany
    ]?.name || '';

  const tsModalFormValues: VehicleFormInterface = {
    ...tsModalValues,
    registerCompany,
    paymentDate: tsModalValues.paymentDate
      ? dayjs(tsModalValues.paymentDate).format('YYYY-MM-DD')
      : '',
    registerDate: tsModalValues.registerDate
      ? dayjs(tsModalValues.registerDate).format('YYYY-MM-DD')
      : ''
  };

  const filteredValues = filterVehicleFieldsByVisibility(
    tsModalFormValues,
    visibleFields
  );

  return filteredValues;
};

export const filterVehicleFieldsByVisibility = (
  data: Partial<VehicleFormInterface>,
  visibleFields: (keyof VehicleFormInterface)[]
): Partial<VehicleFormInterface> => {
  const filtered: Partial<VehicleFormInterface> = {};
  visibleFields.forEach((field) => {
    filtered[field] = data[field];
  });
  return filtered;
};
